import React, { Component } from "react";

import { FolderIcon, ReportSvg, RightChevron, CloseReportIcon } from "../../../lib/icons";
import { connect } from "react-redux";
import PowerBISubFolder from "./powerBISubFolder";
import { OverlayTrigger, Tooltip, Popover } from "react-bootstrap";
import moment from "moment";
import { isNodeOpen, isNodeOpenInStack, isRouteMatch } from "../../../lib/reportingNavigation";

class PowerBIFolder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
    };
    this.collapseHandler = this.collapseHandler.bind(this);
    this.renderCollapsible = this.renderCollapsible.bind(this);
    this.onClick = this.onClick.bind(this);
  }
  collapseHandler(e, rpt) {
    e.stopPropagation();
    e.preventDefault();
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }));
  }
  renderCollapsible() {
    return (
      <div className="menu-list-collapse">
        <RightChevron
          transform={this.state.collapsed ? "" : "rotate(90,12,12)"}
          height={"20px"}
          // width={"24px"}
          color={"rgba(88, 89, 91, 1)"}
          viewBox={"-1 2 24 24"}
        />
      </div>
    );
    //}
  }
  onClick(event, report, workspace) {
    // let wIndex;
    // let rIndex;
    // this.props.workspaces.forEach((ws, idx) => {
    //   if (ws._id === report.workspace) {
    //     wIndex = idx;
    //   }
    // });
    this.props.clickReportHandler(event, workspace, report);
  }
  renderTableItem(report) {
    if (report.pbiCreatedDate === undefined || report.pbiCreatedDate === null) {
      return (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ paddingRight: "310px" }}>{moment(report.pbiModifiedDate).format("MM/DD/YY")}</div>
          <div>-</div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ paddingRight: "250px" }}>{moment(report.pbiModifiedDate).format("MM/DD/YY")}</div>
          <div>{moment(report.pbiCreatedDate).format("MM/DD/YY")}</div>
        </div>
      );
    }
  }
  renderChildren(nodes, leftCaret = false, dontShowDates) {
    let rptPadding = 22;

    return nodes.map((node, idx) => {
      if (node.fileType === "folder") {
        return (
          <PowerBISubFolder
            clickReportHandler={this.props.clickReportHandler}
            key={idx}
            report={node}
            workspace={this.props.workspace}
            leftCaret={leftCaret}
            routeSelection={this.props.routeSelection}
            openKeys={this.props.openKeys}
            wsStack={this.props.wsStack}
            removeHandler={this.props.removeHandler}
          />
        );
      }

      if (leftCaret) {
        const active = isRouteMatch(node, this.props.routeSelection);
        const isOpen = isNodeOpen(node, this.props.openKeys) || isNodeOpenInStack(node, this.props.wsStack);
        const canClose = active || isOpen;
        let stateClass = "tab tab-unselected";
        if (active) {
          stateClass = "tab tab-selected";
        } else if (isOpen) {
          stateClass = "tab tab-open";
        }

        return (
          <OverlayTrigger
            key={idx + "-tip1"}
            placement={"top"}
            rootClose={true}
            trigger={["hover", "focus"]}
            overlay={
              <Popover id={idx + "-tip1"}>
                <Popover.Header as="h3">{node.workspaceName}</Popover.Header>
                <Popover.Body>
                  {node.name}
                  {node.description ? (
                    <div>
                      <hr></hr> {node.description}
                    </div>
                  ) : (
                    ""
                  )}
                  {node !== undefined && node.pbiModifiedDate ? (
                    <div style={{ display: "flex", flexDirectin: "row" }}>
                      <div style={{ paddingRight: "5px" }}>Modified:</div> {moment(node.pbiModifiedDate).format("MM/DD/YY")}
                    </div>
                  ) : null}
                  {node !== undefined && node.pbiCreatedDate ? (
                    <div style={{ display: "flex", flexDirectin: "row" }}>
                      <div style={{ paddingRight: "5px" }}>Created:</div> {moment(node.pbiCreatedDate).format("MM/DD/YY")}
                    </div>
                  ) : null}
                </Popover.Body>
              </Popover>
            }>
            <div
              onClick={(event) => {
                this.onClick(event, node, this.props.workspace);
              }}
              className={"ta-workspace-reports-span powerBIFolder"}
              key={"rpt" + idx}
              style={{
                marginLeft: `${rptPadding}px`,
                display: "flex",
                flexDirection: "row",
              }}>
              <ReportSvg
                height={"16px"}
                style={{ display: "flex", flexDirection: "row", flexShrink: 0 }}
                className={"ta-pbi-icon"}
                color={"rgba(121, 121, 121, 1)"}
                viewBox={"0 -1 24 24"}
              />
              <div
                className={`${stateClass} nav-item-row`}
                style={{
                  paddingLeft: "0px",
                  marginLeft: "1px",
                  marginTop: "-6px",
                  width: "100%",
                }}>
                <span className="nav-item-label">{node.name}</span>
                {!dontShowDates && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flexShrink: 0,
                      marginLeft: "auto",
                      marginRight: "65px",
                    }}>
                    {this.renderTableItem(node)}
                  </div>
                )}
              </div>
              {canClose && (
                <OverlayTrigger
                  key={"closereport-tip"}
                  placement={"right"}
                  overlay={<Tooltip id={"closereport-tip"}>Close Report</Tooltip>}>
                  <div
                    className="close-report-icon"
                    style={{
                      display: "inline",
                      flexShrink: 0,
                      paddingLeft: "13px",
                      cursor: "pointer",
                      marginTop: "-6px",
                    }}
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      this.props.removeHandler(event, node);
                    }}>
                    <CloseReportIcon height={"15px"} viewBox={"0 0 20 20"} color={"#58595B"} />
                  </div>
                </OverlayTrigger>
              )}
            </div>
          </OverlayTrigger>
        );
      }
      return (
        <div
          onClick={(event) => {
            this.onClick(event, node, this.props.workspace);
          }}
          key={"rpt" + idx}
          style={{ marginLeft: `${rptPadding}px` }}
          className="ta-report-name">
          <ReportSvg height={"16px"} className={"ta-pbi-icon"} color={"rgba(121, 121, 121, 1)"} viewBox={"0 -1 24 24"} />
          {node.name}
        </div>
      );
    });
  }
  render() {
    const { collapsed } = this.state;
    const { leftSideCaret, dontShowDates } = this.props;
    if (dontShowDates !== undefined && dontShowDates !== null && dontShowDates) {
      return (
        <div style={{ marginLeft: "-4px" }}>
          <div className="ta-folder-name-left-caret" onClick={(e) => this.collapseHandler(e, this.props.report)}>
            <div className="nav-item-row">
              <span className="nav-item-icon-slot">{this.renderCollapsible()}</span>
              <span className="nav-item-label">{this.props.report.name}</span>
            </div>
          </div>
          {collapsed ? null : <div>{this.renderChildren(this.props.report.children, true, true)}</div>}
        </div>
      );
    }
    if (leftSideCaret !== undefined && leftSideCaret === true) {
      return (
        <div style={{ marginLeft: "-4px" }}>
          <div className="ta-folder-name-left-caret" onClick={(e) => this.collapseHandler(e, this.props.report)}>
            <div className="nav-item-row">
              <span className="nav-item-icon-slot">{this.renderCollapsible()}</span>
              <span className="nav-item-label">{this.props.report.name}</span>
              {this.props.report.pbiModifiedDate}
            </div>
          </div>
          {collapsed ? null : <div>{this.renderChildren(this.props.report.children, true)}</div>}
        </div>
      );
    }
    return (
      <div>
        <div
          className="ta-folder-name"
          style={{ display: "flex", flexDirection: "column" }}
          onClick={() => this.collapseHandler(this.props.report)}>
          <div className="nav-item-row">
            <FolderIcon
              height={"14px"}
              className={"ta-folder-icon"}
              color={"rgba(121, 121, 121, 1)"}
              style={{ flexShrink: 0 }}
            />
            <span className="nav-item-label">{this.props.report.name}</span>
            {this.props.report.pbiModifiedDate}

            <span className="nav-item-icon-slot">{this.renderCollapsible()}</span>
          </div>
        </div>
        {/* {collapsed ? null : (
          <div>{this.renderChildren(this.props.report.children)}</div>
        )} */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  workspaces: state.reportList.workspaces,
  apps: state.app.apps,
  performCollapseAction: state.app.performCollapseAction,
  collapseFolders: state.app.collapseFolders,
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PowerBIFolder);
